import React from 'react'
import styled, { css } from 'styled-components'
import { color } from 'utils'

const selectedStyles = css`
  border-radius: 6px;
  background-color: ${color('dark900')};
  color: ${color('blue600')};
  box-shadow: 0px 4px 8px rgba(5, 24, 61, 0.1);
`

const BaseTabMenuItem = styled.span<{ disabled: boolean; selected: boolean; width?: string }>`
  position: relative;
  padding: 12px 14px;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  border-radius: 8px;
  white-space: nowrap;
  width: ${(props) => props.width ?? 'auto'};
  margin: 2px;
  color: ${color('grey400')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  ${({ selected }) => selected && selectedStyles}
  transition: color 0.3s, background-color 0.3s;

  &:hover {
    color: ${(props) => (props.disabled ? color('grey400') : color('white'))};
  }

  @media (max-width: 767px) {
    font-size: 13px;
    padding: 10px 16px;
  }
`

const TabMenuNewItem = (props) => {
  const { children, className, selected, ...rest } = props
  const isSelectedOrActive = selected || className === 'active'

  return (
    <BaseTabMenuItem selected={isSelectedOrActive} {...rest}>
      {children}
    </BaseTabMenuItem>
  )
}

export default TabMenuNewItem
